// src/components/Stats.js
import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export default function Stats({ gameScore, gameDailyScore, teamScores, team, dailyAttempts, bonusAttempts }) {
    const { t } = useLanguage();

    return (
        <>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
                <div className="bg-gray-800 p-4 rounded-lg">
                    <p className="text-sm text-gray-400">{t('myScore')}</p>
                    <p className="text-sm font-bold">{gameScore}</p>
                </div>

                <div className="bg-gray-800 p-4 rounded-lg">
                    <p className="text-sm text-gray-400">{t('myDailyScore')}</p>
                    <p className="text-sm font-bold">
                        {gameDailyScore}
                    </p>
                </div>

                <div className="bg-gray-800 p-4 rounded-lg">
                    <p className="text-sm text-gray-400">{t('dailyAttempts')}</p>
                    <p className="text-sm font-bold">{dailyAttempts}</p>
                </div>

                <div className="bg-gray-800 p-4 rounded-lg">
                    <p className="text-sm text-gray-400">{t('bonusAttempts')}</p>
                    <p className="text-sm font-bold">{bonusAttempts}</p>
                </div>
            </div>

            <div className="bg-gray-800 p-4 rounded-lg mb-6">
                <div className="flex justify-between items-center">
                    <div className="flex flex-col items-center px-4">
                        <div className="flex items-center gap-2">
                            <span className="text-lg">⚫⚪</span>
                            <p className="text-3xl font-bold">{teamScores.blackWhite || 0}</p>
                        </div>
                        <span className="text-lg font-bold text-gray-400">{t('blackWhiteTeam')}</span>
                    </div>
                    <div className="text-xl font-bold text-gray-500">VS</div>
                    <div className="flex flex-col items-center px-4">
                        <div className="flex items-center gap-2">
                            <span className="text-lg">🔴⚪</span>
                            <p className="text-3xl font-bold">{teamScores.redWhite || 0}</p>
                        </div>
                        <span className="text-lg font-bold text-gray-400">{t('redWhiteTeam')}</span>
                    </div>
                </div>

                {/*{ballSpeed > 2 && (*/}
                {/*  <p className="text-center text-yellow-400 mt-2">*/}
                {/*      {t('teamLeading')} - {t('speedIncrease')}: {((ballSpeed - 2) * 50).toFixed(0)}%*/}
                {/*  </p>*/}
                {/*)}*/}
            </div>
        </>
    );
}